// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-styles----footer-module---footer---2KdhN","logoTitle":"src-styles----footer-module---logoTitle---2qXzO","links":"src-styles----footer-module---links---3JIJ-","copyright":"src-styles----footer-module---copyright---sTIJ6"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/footer.module.styl
// module id = 570
// module chunks = 114276838955818